import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import AlertDetail from './components/AlertDetail';
import AlertLinking from './components/AlertLinking';
import GlobalAlert from './components/GlobalAlert';
import AlertFeed from './components/AlertFeed';
import TrapAlertHistory from './components/TrapAlertHistory';
import OtherSensors from './components/OtherSensors';
import RodentStations from './components/RodentStations';
import BedbugTraps from './components/BedbugTraps';
import GlobalTrapAlertBanner from './components/GlobalTrapAlertBanner';

function App() {
  return (
    <Router>
      <div className="App">
        <GlobalTrapAlertBanner />
        <Routes>
          <Route path="/" element={<GlobalAlert />} />
          <Route path="/details/:deviceId" element={<AlertDetail />} />
          <Route path="/linking/:id" element={<AlertLinking />} />
          <Route path="/alerts" element={<AlertFeed />} />
          <Route path="/other-sensors" element={<OtherSensors />} />
          <Route path="/rodent-stations" element={<RodentStations />} />
          <Route path="/bedbug-traps" element={<BedbugTraps />} />
          <Route path="/trap-alert-history" element={<TrapAlertHistory />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

